import React, { useEffect, useState } from 'react';
import { MdDarkMode, MdLightMode } from "react-icons/md"; // Import the icons

const DarkModeToggle = () => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Check if dark mode is enabled in user's system preferences
    const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    return localStorage.getItem('theme') ? localStorage.getItem('theme') === 'dark' : prefersDarkMode;
  });

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [isDarkMode]);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <button onClick={toggleDarkMode} className="p-2 bg-gray-200 dark:bg-gray-700 rounded">
      {isDarkMode ? <MdLightMode className="text-yellow-500" /> : <MdDarkMode className="text-gray-800" />}
    </button>
  );
};

export default DarkModeToggle;